import React from "react";

import { ITeachingMaterial } from "../../../state";
import Button from "../../../atoms/ActiveLearning/Button";

import styles from "./Prompt.module.scss";

export type PromptProps = {
  OPPAType: "before" | "after" | null;
  teachingMaterial: ITeachingMaterial | undefined;
  onInputOPPA: () => void;
  onNext: () => void;
};

const Prompt: React.FC<PromptProps> = ({
  OPPAType,
  teachingMaterial,
  onInputOPPA,
  onNext,
}) => {
  const titleWithoutEducationLevel = teachingMaterial?.title.replace(
    /\s*-高校-|\s*-中学-/g,
    "",
  );
  const promptMessages = {
    before: "Lessonに入る前に、Before WORKに回答しましょう。",
    after: `${teachingMaterial?.name}「${titleWithoutEducationLevel}」での学びを振り返りましょう。`,
  };
  const buttonLabels = {
    before: "Before WORKに回答する",
    after: "After WORKに回答する",
  };

  return (
    <div className={styles.prompt}>
      <div className={styles.wrapper}>
        <p className={styles.message}>
          {OPPAType ? promptMessages[OPPAType] : ""}
        </p>
        <div className={styles.buttons}>
          <Button
            variant={"primary"}
            width={"240px"}
            height={"40px"}
            fontSize={"14px"}
            handleClick={onInputOPPA}
          >
            {OPPAType ? buttonLabels[OPPAType] : ""}
          </Button>
          <Button
            variant={"secondaryBgWhite"}
            width={"240px"}
            height={"40px"}
            fontSize={"14px"}
            handleClick={onNext}
          >
            次のページに進む
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Prompt;
